// Feature flags (Vite env)
//
// Enable the planned pages (/catalog, /story, /news, /shop, /contact):
//   VITE_ENABLE_FUTURE_PAGES=true
export const ENABLE_FUTURE_PAGES: boolean = String(import.meta.env.VITE_ENABLE_FUTURE_PAGES || '').toLowerCase() === 'true'
